/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const AddressLineRepairResultDTOOutcomeEnum = {
    Repaired: 'REPAIRED',
    Unchanged: 'UNCHANGED',
    Manual: 'MANUAL'
};
/**
 * Check if a given object implements the AddressLineRepairResultDTO interface.
 */
export function instanceOfAddressLineRepairResultDTO(value) {
    return true;
}
export function AddressLineRepairResultDTOFromJSON(json) {
    return AddressLineRepairResultDTOFromJSONTyped(json, false);
}
export function AddressLineRepairResultDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'before': json['before'] == null ? undefined : json['before'],
        'after': json['after'] == null ? undefined : json['after'],
        'stateFilled': json['stateFilled'] == null ? undefined : json['stateFilled'],
        'outcome': json['outcome'] == null ? undefined : json['outcome'],
    };
}
export function AddressLineRepairResultDTOToJSON(json) {
    return AddressLineRepairResultDTOToJSONTyped(json, false);
}
export function AddressLineRepairResultDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amazonOrderId': value['amazonOrderId'],
        'createdBy': value['createdBy'],
        'before': value['before'],
        'after': value['after'],
        'stateFilled': value['stateFilled'],
        'outcome': value['outcome'],
    };
}
